<template>
  <div v-bind="$attrs"
       v-on="$listeners"
       :class="$style.container"
       :style="containerStyle">
    <div :style="innerContainerStyle">
      <div :class="$style.topContainer"
           :style="topContainerStyle">
        <slot name="top" />
      </div>
      <div :style="optionsContainerStyle">
        <div v-for="(option, index) in options" :key="index"
             :class="$style.optionContainer"
             :style="optionContainerStyle"
             @click="selected(index)">
          <slot name="option"
                :index="index"
                :option="option"
                :text="text(index)"
                :textLeft="textLeft(index)"
                :textRight="textRight(index)" />
          <div :style="optionLeftContainerStyle">
            <div :style="optionLeftLeftStyle">
              <slot name="option-left-left"
                    :option="option"
                    :index="index" />
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.bottomContainer"
           :style="bottomContainerStyle">
        <slot name="bottom" />
      </div>
    </div>
  </div>
</template>

<script>
  import { DefaultPseudoClassAttributeNames,
           DefaultPseudoClassVariableNames,
           getPseudoClassesObject,
           filterObjectByArray} from '@js/vue-style-utils'
  import { splitString } from '@js/str-utils'

  export default {
    name: 'BaseOptions',
    inheritAttrs: false,
    props: {
      checkInputOverlapping: { type: Boolean, required: false, default: false },
      enableScrollY: { type: Boolean, required: false, default: false },
      input: { type: String, required: false, default: '' },
      options: { type: Array, required: true },
    },
    data: function () {
      return {
        bottomContainerStyle: {
          boxSizing: 'border-box',
        },
        containerStyle: {
          alignItems: 'flex-start',
          boxSizing: 'border-box',
          display: 'flex',
          justifyContent: 'center',
          zIndex: 1,
        },
        innerContainerStyle: {
          alignItems: 'space-between',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          width: '100%',
        },
        optionContainerStyle: {
          alignItems: 'center',
          boxSizing: 'border-box',
          display: 'flex',
          justifyContent: 'space-between',
        },
        optionLeftCenterStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'flex-start',
        },
        optionLeftContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'flex-start',
        },
        optionLeftLeftStyle: {},
        optionLeftRightStyle: {},
        optionsContainerStyle: {
          boxSizing: 'border-box',
        },
        optionRightContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-end',
        },
        optionRightLeftStyle: {},
        optionRightRightStyle: {},
        optionStyle: {},
        optionTextLeftStyle: {},
        optionTextRightStyle: {},
        optionTextStyle: {},
        postfixes: ['', 'hover', 'active', 'disabled', 'selected', 'hover-selected'],
        topContainerStyle: {},
      };
    },
    created: function () {
      let classObject = getPseudoClassesObject(
        this.$attrs.bottomContainerStyle, DefaultPseudoClassAttributeNames,
        '--base-options-bottom-container-', DefaultPseudoClassVariableNames,
        this.postfixes);
      let attrs = filterObjectByArray(
        this.$attrs.bottomContainerStyle, DefaultPseudoClassAttributeNames);

      this.bottomContainerStyle = {
        ...this.bottomContainerStyle,
        ...attrs,
        ...classObject,
      };

      classObject = getPseudoClassesObject(
        this.$attrs.containerStyle, DefaultPseudoClassAttributeNames,
        '--base-options-container-', DefaultPseudoClassVariableNames,
        this.postfixes);
      attrs = filterObjectByArray(
        this.$attrs.containerStyle, DefaultPseudoClassAttributeNames);

      this.containerStyle = {
        ...this.containerStyle,
        ...attrs,
        ...classObject,
      };

      this.innerContainerStyle = {
        ...this.innerContainerStyle,
        ...this.$attrs.innerContainerStyle,
      };

      classObject = getPseudoClassesObject(
        this.$attrs.optionContainerStyle, DefaultPseudoClassAttributeNames,
        '--base-options-option-container-', DefaultPseudoClassVariableNames,
        this.postfixes);
      attrs = filterObjectByArray(
        this.$attrs.optionContainerStyle, DefaultPseudoClassAttributeNames);

      this.optionContainerStyle = {
        ...this.optionContainerStyle,
        ...attrs,
        ...classObject,
      };

      this.optionLeftCenterStyle = {
        ...this.optionLeftCenterStyle,
        ...this.$attrs.optionLeftCenterStyle,
      };

      this.optionLeftContainerStyle = {
        ...this.optionLeftContainerStyle,
        ...this.$attrs.optionLeftContainerStyle,
      };

      this.optionLeftLeftStyle = {
        ...this.optionLeftLeftStyle,
        ...this.$attrs.optionLeftLeftStyle,
      };

      this.optionLeftRightStyle = {
        ...this.optionLeftRightStyle,
        ...this.$attrs.optionLeftRightStyle,
      };

      this.optionsContainerStyle = {
        ...this.optionsContainerStyle,
        ...this.$attrs.optionsContainerStyle,
      };

      this.optionRightContainerStyle = {
        ...this.optionRightContainerStyle,
        ...this.$attrs.optionRightContainerStyle,
      };

      this.optionRightLeftStyle = {
        ...this.optionRightLeftStyle,
        ...this.$attrs.optionRightLeftStyle,
      };

      this.optionRightRightStyle = {
        ...this.optionRightRightStyle,
        ...this.$attrs.optionRightRightStyle,
      };

      this.optionStyle = {
        ...this.optionStyle,
        ...this.$attrs.optionStyle,
      };

      classObject = getPseudoClassesObject(
        this.$attrs.optionTextLeftStyle, DefaultPseudoClassAttributeNames,
        '--base-options-option-text-left-',
        DefaultPseudoClassVariableNames, this.postfixes);
      attrs = filterObjectByArray(
        this.$attrs.optionTextLeftStyle, DefaultPseudoClassAttributeNames);

      this.optionTextLeftStyle = {
        ...this.optionTextLeftStyle,
        ...attrs,
        ...classObject,
      };

      classObject = getPseudoClassesObject(
        this.$attrs.optionTextRightStyle, DefaultPseudoClassAttributeNames,
        '--base-options-option-text-right-',
        DefaultPseudoClassVariableNames, this.postfixes);
      attrs = filterObjectByArray(
        this.$attrs.optionTextRightStyle, DefaultPseudoClassAttributeNames);

      this.optionTextRightStyle = {
        ...this.optionTextRightStyle,
        ...attrs,
        ...classObject,
      };

      classObject = getPseudoClassesObject(
        this.$attrs.optionTextStyle, DefaultPseudoClassAttributeNames,
        '--base-options-option-text-',
        DefaultPseudoClassVariableNames, this.postfixes);
      attrs = filterObjectByArray(
        this.$attrs.optionTextStyle, DefaultPseudoClassAttributeNames);

      this.optionTextStyle = {
        ...this.optionTextStyle,
        ...attrs,
        ...classObject,
      };

      classObject = getPseudoClassesObject(
        this.$attrs.topContainerStyle, DefaultPseudoClassAttributeNames,
        '--base-options-top-container-', DefaultPseudoClassVariableNames,
        this.postfixes);
      attrs = filterObjectByArray(
        this.$attrs.topContainerStyle, DefaultPseudoClassAttributeNames);

      this.topContainerStyle = {
        ...this.topContainerStyle,
        ...attrs,
        ...classObject,
      };
    },
    methods: {
      selected: function (optionIndex) {
        this.$emit('selected', optionIndex);
      },
      text: function (optionIndex) {
        const display = this.options[optionIndex].display ? this.options[optionIndex].display : this.options[optionIndex];
        return this.options.length > 0 ? splitString(display, this.input)[1] : this.input;
      },
      textLeft: function (optionIndex) {
        const display = this.options[optionIndex].display ? this.options[optionIndex].display : this.options[optionIndex];
        return this.options.length > 0 ? splitString(display, this.input)[0] : '';
      },
      textRight: function (optionIndex) {
        const display = this.options[optionIndex].display ? this.options[optionIndex].display : this.options[optionIndex];
        return this.options.length > 0 ? splitString(display, this.input)[2] : '';
      },
    },
  };
</script>

<style lang="stylus" module>
  .bottomContainer
    background-color var(--base-options-bottom-container-background-color)
    border var(--base-options-bottom-container-border)
    border-radius var(--base-options-bottom-container-border-radius)
    border-width var(--base-options-bottom-container-border-width)
    box-shadow var(--base-options-bottom-container-box-shadow)
    &:hover
      background-color var(--base-options-bottom-container-background-color-hover)
      border var(--base-options-bottom-container-border-hover)
      border-radius var(--base-options-bottom-container-border-radius-hover)
      border-width var(--base-options-bottom-container-border-width-hover)
      box-shadow var(--base-options-bottom-container-box-shadow-hover)
    &:active
      background-color var(--base-options-bottom-container-background-color-active)
      border var(--base-options-bottom-container-border-active)
      border-radius var(--base-options-bottom-container-border-radius-active)
      border-width var(--base-options-bottom-container-border-width-active)
      box-shadow var(--base-options-bottom-container-box-shadow-active)
    &[disabled]
      background-color var(--base-options-bottom-container-background-color-disabled)
      border var(--base-options-bottom-container-border-disabled)
      border-radius var(--base-options-bottom-container-border-radius-disabled)
      border-width var(--base-options-bottom-container-border-width-disabled)
      box-shadow var(--base-options-bottom-container-box-shadow-disabled)
    &[selected]
      background-color var(--base-options-bottom-container-background-color-selected)
      border var(--base-options-bottom-container-border-selected)
      border-radius var(--base-options-bottom-container-border-radius-selected)
      border-width var(--base-options-bottom-container-border-width-selected)
      box-shadow var(--base-options-bottom-container-box-shadow-selected)
    &:hover[selected]
      background-color var(--base-options-bottom-container-background-color-hover-selected)
      border var(--base-options-bottom-container-border-hover-selected)
      border-radius var(--base-options-bottom-container-border-radius-hover-selected)
      border-width var(--base-options-bottom-container-border-width-hover-selected)
      box-shadow var(--base-options-bottom-container-box-shadow-hover-selected)

  .container
    background-color var(--base-options-container-background-color)
    border var(--base-options-container-border)
    border-radius var(--base-options-container-border-radius)
    border-width var(--base-options-container-border-width)
    box-shadow var(--base-options-container-box-shadow)
    &:hover
      background-color var(--base-options-container-background-color-hover)
      border var(--base-options-container-border-hover)
      border-radius var(--base-options-container-border-radius-hover)
      border-width var(--base-options-container-border-width-hover)
      box-shadow var(--base-options-container-box-shadow-hover)
    &[selected]
      background-color var(--base-options-container-background-color-selected)
      border var(--base-options-container-border-selected)
      border-radius var(--base-options-container-border-radius-selected)
      border-width var(--base-options-container-border-width-selected)
      box-shadow var(--base-options-container-box-shadow-selected)

  .optionContainer
    background-color var(--base-options-option-container-background-color)
    border var(--base-options-option-container-border)
    border-radius var(--base-options-option-container-border-radius)
    border-width var(--base-options-option-container-border-width)
    box-shadow var(--base-options-option-container-box-shadow)
    color var(--base-options-option-container-color)
    cursor var(--base-options-option-container-cursor)
    font-family var(--base-options-option-container-font-family)
    font-size var(--base-options-option-container-font-size)
    font-weight var(--base-options-option-container-font-weight)
    text-decoration var(--base-options-option-container-text-decoration)
    &:hover
      background-color var(--base-options-option-container-background-color-hover)
      border var(--base-options-option-container-border-hover)
      border-radius var(--base-options-option-container-border-radius-hover)
      border-width var(--base-options-option-container-border-width-hover)
      box-shadow var(--base-options-option-container-box-shadow-hover)
      color var(--base-options-option-container-color-hover)
      cursor var(--base-options-option-container-cursor-hover)
      font-family var(--base-options-option-container-font-family-hover)
      font-size var(--base-options-option-container-font-size-hover)
      font-weight var(--base-options-option-container-font-weight-hover)
      text-decoration var(--base-options-option-container-text-decoration-hover)
    &:active
      background-color var(--base-options-option-container-background-color-active)
      border var(--base-options-option-container-border-active)
      border-radius var(--base-options-option-container-border-radius-active)
      border-width var(--base-options-option-container-border-width-active)
      box-shadow var(--base-options-option-container-box-shadow-active)
      color var(--base-options-option-container-color-active)
      cursor var(--base-options-option-container-cursor-active)
      font-family var(--base-options-option-container-font-family-active)
      font-size var(--base-options-option-container-font-size-active)
      font-weight var(--base-options-option-container-font-weight-active)
      text-decoration var(--base-options-option-container-text-decoration-active)
    &[disabled]
      background-color var(--base-options-option-container-background-color-disabled)
      border var(--base-options-option-container-border-disabled)
      border-radius var(--base-options-option-container-border-radius-disabled)
      border-width var(--base-options-option-container-border-width-disabled)
      box-shadow var(--base-options-option-container-box-shadow-disabled)
      color var(--base-options-option-container-color-disabled)
      cursor var(--base-options-option-container-cursor-disabled)
      font-family var(--base-options-option-container-font-family-disabled)
      font-size var(--base-options-option-container-font-size-disabled)
      font-weight var(--base-options-option-container-font-weight-disabled)
      text-decoration var(--base-options-option-container-text-decoration-disabled)
    &[selected]
      background-color var(--base-options-option-container-background-color-selected)
      border var(--base-options-option-container-border-selected)
      border-radius var(--base-options-option-container-border-radius-selected)
      border-width var(--base-options-option-container-border-width-selected)
      box-shadow var(--base-options-option-container-box-shadow-selected)
      color var(--base-options-option-container-color-selected)
      cursor var(--base-options-option-container-cursor-selected)
      font-family var(--base-options-option-container-font-family-selected)
      font-size var(--base-options-option-container-font-size-selected)
      font-weight var(--base-options-option-container-font-weight-selected)
      text-decoration var(--base-options-option-container-text-decoration-selected)
    &:hover[selected]
      background-color var(--base-options-option-container-background-color-hover-selected)
      border var(--base-options-option-container-border-hover-selected)
      border-radius var(--base-options-option-container-border-radius-hover-selected)
      border-width var(--base-options-option-container-border-width-hover-selected)
      box-shadow var(--base-options-option-container-box-shadow-hover-selected)
      color var(--base-options-option-container-color-hover-selected)
      cursor var(--base-options-option-container-cursor-selected)
      font-family var(--base-options-option-container-font-family-hover-selected)
      font-size var(--base-options-option-container-font-size-hover-selected)
      font-weight var(--base-options-option-container-font-weight-hover-selected)
      text-decoration var(--base-options-option-container-text-decoration-hover-selected)

  .optionText
    color var(--base-options-option-text-color)
    font-family var(--base-options-option-text-font-family)
    font-size var(--base-options-option-text-font-size)
    font-weight var(--base-options-option-text-font-weight)
    text-decoration var(--base-options-option-text-text-decoration)
    &:hover
      color var(--base-options-option-text-color-hover)
      font-family var(--base-options-option-text-font-family-hover)
      font-size var(--base-options-option-text-font-size-hover)
      font-weight var(--base-options-option-text-font-weight-hover)
      text-decoration var(--base-options-option-text-text-decoration-hover)
    &:active
      color var(--base-options-option-text-color-active)
      font-family var(--base-options-option-text-font-family-active)
      font-size var(--base-options-option-text-font-size-active)
      font-weight var(--base-options-option-text-font-weight-active)
      text-decoration var(--base-options-option-text-text-decoration-active)
    &[disabled]
      color var(--base-options-option-text-color-disabled)
      font-family var(--base-options-option-text-font-family-disabled)
      font-size var(--base-options-option-text-font-size-disabled)
      font-weight var(--base-options-option-text-font-weight-disabled)
      text-decoration var(--base-options-option-text-text-decoration-disabled)
    &[selected]
      color var(--base-options-option-text-color-selected)
      font-family var(--base-options-option-text-font-family-selected)
      font-size var(--base-options-option-text-font-size-selected)
      font-weight var(--base-options-option-text-font-weight-selected)
      text-decoration var(--base-options-option-text-text-decoration-selected)
    &:hover[selected]
      color var(--base-options-option-text-color-hover-selected)
      font-family var(--base-options-option-text-font-family-hover-selected)
      font-size var(--base-options-option-text-font-size-hover-selected)
      font-weight var(--base-options-option-text-font-weight-hover-selected)
      text-decoration var(--base-options-option-text-text-decoration-hover-selected)

  .optionTextLeft
    color var(--base-options-option-text-left-color)
    font-family var(--base-options-option-text-left-font-family)
    font-size var(--base-options-option-text-left-font-size)
    font-weight var(--base-options-option-text-left-font-weight)
    text-decoration var(--base-options-option-text-left-text-decoration)
    &:hover
      color var(--base-options-option-text-left-color-hover)
      font-family var(--base-options-option-text-left-font-family-hover)
      font-size var(--base-options-option-text-left-font-size-hover)
      font-weight var(--base-options-option-text-left-font-weight-hover)
      text-decoration var(--base-options-option-text-left-text-decoration-hover)
    &:active
      color var(--base-options-option-text-left-color-active)
      font-family var(--base-options-option-text-left-font-family-active)
      font-size var(--base-options-option-text-left-font-size-active)
      font-weight var(--base-options-option-text-left-font-weight-active)
      text-decoration var(--base-options-option-text-left-text-decoration-active)
    &[disabled]
      color var(--base-options-option-text-left-color-disabled)
      font-family var(--base-options-option-text-left-font-family-disabled)
      font-size var(--base-options-option-text-left-font-size-disabled)
      font-weight var(--base-options-option-text-left-font-weight-disabled)
      text-decoration var(--base-options-option-text-left-text-decoration-disabled)
    &[selected]
      color var(--base-options-option-text-left-color-selected)
      font-family var(--base-options-option-text-left-font-family-selected)
      font-size var(--base-options-option-text-left-font-size-selected)
      font-weight var(--base-options-option-text-left-font-weight-selected)
      text-decoration var(--base-options-option-text-left-text-decoration-selected)
    &:hover[selected]
      color var(--base-options-option-text-left-color-hover-selected)
      font-family var(--base-options-option-text-left-font-family-hover-selected)
      font-size var(--base-options-option-text-left-font-size-hover-selected)
      font-weight var(--base-options-option-text-left-font-weight-hover-selected)
      text-decoration var(--base-options-option-text-left-text-decoration-hover-selected)

  .optionTextRight
    color var(--base-options-option-text-right-color)
    font-family var(--base-options-option-text-right-font-family)
    font-size var(--base-options-option-text-right-font-size)
    font-weight var(--base-options-option-text-right-font-weight)
    text-decoration var(--base-options-option-text-right-text-decoration)
    &:hover
      color var(--base-options-option-text-right-color-hover)
      font-family var(--base-options-option-text-right-font-family-hover)
      font-size var(--base-options-option-text-right-font-size-hover)
      font-weight var(--base-options-option-text-right-font-weight-hover)
      text-decoration var(--base-options-option-text-right-text-decoration-hover)
    &:active
      color var(--base-options-option-text-right-color-active)
      font-family var(--base-options-option-text-right-font-family-active)
      font-size var(--base-options-option-text-right-font-size-active)
      font-weight var(--base-options-option-text-right-font-weight-active)
      text-decoration var(--base-options-option-text-right-text-decoration-active)
    &[disabled]
      color var(--base-options-option-text-right-color-disabled)
      font-family var(--base-options-option-text-right-font-family-disabled)
      font-size var(--base-options-option-text-right-font-size-disabled)
      font-weight var(--base-options-option-text-right-font-weight-disabled)
      text-decoration var(--base-options-option-text-right-text-decoration-disabled)
    &[selected]
      color var(--base-options-option-text-right-color-selected)
      font-family var(--base-options-option-text-right-font-family-selected)
      font-size var(--base-options-option-text-right-font-size-selected)
      font-weight var(--base-options-option-text-right-font-weight-selected)
      text-decoration var(--base-options-option-text-right-text-decoration-selected)
    &:hover[selected]
      color var(--base-options-option-text-right-color-hover-selected)
      font-family var(--base-options-option-text-right-font-family-hover-selected)
      font-size var(--base-options-option-text-right-font-size-hover-selected)
      font-weight var(--base-options-option-text-right-font-weight-hover-selected)
      text-decoration var(--base-options-option-text-right-text-decoration-hover-selected)

  .topContainer
    background-color var(--base-options-top-container-background-color)
    border var(--base-options-top-container-border)
    border-radius var(--base-options-top-container-border-radius)
    border-width var(--base-options-top-container-border-width)
    box-shadow var(--base-options-top-container-box-shadow)
    &:hover
      background-color var(--base-options-top-container-background-color-hover)
      border var(--base-options-top-container-border-hover)
      border-radius var(--base-options-top-container-border-radius-hover)
      border-width var(--base-options-top-container-border-width-hover)
      box-shadow var(--base-options-top-container-box-shadow-hover)
    &:active
      background-color var(--base-options-top-container-background-color-active)
      border var(--base-options-top-container-border-active)
      border-radius var(--base-options-top-container-border-radius-active)
      border-width var(--base-options-top-container-border-width-active)
      box-shadow var(--base-options-top-container-box-shadow-active)
    &[disabled]
      background-color var(--base-options-top-container-background-color-disabled)
      border var(--base-options-top-container-border-disabled)
      border-radius var(--base-options-top-container-border-radius-disabled)
      border-width var(--base-options-top-container-border-width-disabled)
      box-shadow var(--base-options-top-container-box-shadow-disabled)
    &[selected]
      background-color var(--base-options-top-container-background-color-selected)
      border var(--base-options-top-container-border-selected)
      border-radius var(--base-options-top-container-border-radius-selected)
      border-width var(--base-options-top-container-border-width-selected)
      box-shadow var(--base-options-top-container-box-shadow-selected)
    &:hover[selected]
      background-color var(--base-options-top-container-background-color-hover-selected)
      border var(--base-options-top-container-border-hover-selected)
      border-radius var(--base-options-top-container-border-radius-hover-selected)
      border-width var(--base-options-top-container-border-width-hover-selected)
      box-shadow var(--base-options-top-container-box-shadow-hover-selected)
</style>

